import React from 'react';
import { Link } from 'react-router-dom';
const Footer = () => {
  const navigationLinks = [{
    path: '/',
    label: 'Home'
  }, {
    path: '/about',
    label: 'About Us'
  }, {
    path: '/strategy',
    label: 'Our Strategy'
  }, {
    path: '/team',
    label: 'Our Team'
  }, {
    path: '/contact',
    label: 'Contact Us'
  }];
  return <footer className="bg-gray-900 py-12 border-t border-gray-800" data-id="element-87">
      <div className="max-w-7xl mx-auto px-4" data-id="element-88">
        <div className="flex flex-col items-center gap-8" data-id="element-89">
          <Link to="/" className="transform transition-transform hover:-translate-y-1" data-id="element-90">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/oe4oUgDYZPX1RVXuLZNFcT/Chiro_Venture_-_white_no_background.png" alt="ChiroVenture Logo" className="h-12" data-id="element-91" />
          </Link>
          <nav className="w-full max-w-xs" data-id="element-92">
            <ul className="flex flex-col items-center space-y-4" data-id="element-93">
              {navigationLinks.map(link => <li key={link.path} data-id="element-94">
                  <Link to={link.path} className="text-gray-400 hover:text-[#4ECDC4] transition-all transform hover:-translate-y-1 font-light tracking-normal" data-id="element-95">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </nav>
          <div className="text-center" data-id="element-96">
            <p className="text-gray-400 font-light" data-id="element-97">
              &copy; {new Date().getFullYear()} ChiroVenture. All rights
              reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;